import React from "react";
import { useLocation } from "react-router-dom";
import ContactForm from "./contactForm";
import "./contactForm.css";
import { Row, Col } from "react-bootstrap";
import LogoImg from "../../assets/logo/Ponanandham_logo.png";
import FB from "../../assets/icons/fb.png";
// import Twitter from "../../assets/icons/rightarrow.png";
import Instagram from "../../assets/icons/insta.png";
// import Youtube from "../../assets/icons/utube.png";
import Linkedin from "../../assets/icons/linkedin.png";

const FooterContainer = (props) => {
  const location = useLocation();
  // On the Sangamam thank-you page the footer is still shown, but
  // every link/icon in it becomes display-only — no navigation, no
  // opening external pages. Every other page keeps the footer exactly
  // as before, fully clickable.
  const isThankYouPage = location.pathname === "/sangamam-thankyou";

  const handleShow = () => {
    if (isThankYouPage) return;
    window.location.href = "/privacy";
  };

  const handleLink = (path) => {
    if (isThankYouPage) return;
    window.location.href = `/${path}`;
  };

  const handleIcons = (paths) => {
    if (isThankYouPage) return;
    window.open(paths, "_blank");
  };
  return (
    <div className="footer-container-anadham">
      <ContactForm />
      <div className="footer-sub-container">
        <Row>
          <Col md={6}>
            <Row>
              <Row>
                <img className="footer-logoimg" src={LogoImg} alt="logo" />
              </Row>
              <Row className="footer-content-p">
                <p>
                  Anadham Plots, a trusted plot developer based in Chennai,
                  offers premium residential plots at unbeatable prices in
                  rapidly developing locations. With excellent connectivity,
                  abundant groundwater, and plots ready for immediate
                  construction, they provide the perfect blend of value,
                  convenience, and investment potential for homebuyers and
                  investors alike.
                </p>
              </Row>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col
                className={`qck-link${isThankYouPage ? " footer-links-disabled" : ""}`}
                md={6}
              >
                <h4>Quick Links</h4>
                <div onClick={() => handleLink("")}>Home</div>
                <div onClick={() => handleLink("aboutus")}>About Us</div>
                <div onClick={() => handleLink("blogs")}>Blogs</div>
                <div onClick={() => handleLink("contactus")}>Contact Us</div>
              </Col>
              {/* <Col className="qck-link" md={4}>
                <h4>Quick Links</h4>
                <div>seller spot</div>
                <div>careers</div>
                <div>core team</div>                
              </Col> */}
              <Col
                className={`qck-link${isThankYouPage ? " footer-links-disabled" : ""}`}
                md={6}
              >
                <h4>Our Projects</h4>
                <div onClick={() => handleLink("kanchipuram")}>Kanchipuram</div>
                <div onClick={() => handleLink("sholavaram")}>Sholavaram</div>

                <div onClick={() => handleLink("sangamam")}>Thirupporur</div>
                <div onClick={() => handleLink("padappai")}>Padappai</div>
              </Col>
            </Row>
            <br />
            <Row className="footer-margin-bottom footer-text-indent">
              Follow Us On
            </Row>
            <Row
              className={`footer-social-icons${isThankYouPage ? " footer-links-disabled" : ""}`}
            >
              <img
                src={FB}
                alt="facebook"
                width="100%"
                onClick={() =>
                  handleIcons(
                    "https://www.facebook.com/profile.php?id=61576391313069",
                  )
                }
              />
              {/* <img src={Twitter} alt="twitter" width="100%" onClick={()=>handleIcons("kanchipuram")}/> */}
              <img
                src={Instagram}
                alt="instagram"
                onClick={() =>
                  handleIcons("https://www.instagram.com/anandham_plots/")
                }
              />
              <img
                src={Linkedin}
                alt="Linkedin"
                onClick={() =>
                  handleIcons(
                    "https://www.linkedin.com/company/anandham-plots/",
                  )
                }
              />
            </Row>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col className="footer-last-container">
            All rights reserved © {new Date().getFullYear()} R3 SKYLINE
            DEVELOPERS LLP |
            <span
              className={isThankYouPage ? "footer-links-disabled" : ""}
              style={{ cursor: isThankYouPage ? "default" : "pointer" }}
              onClick={() => handleShow()}
            >
              {" "}
              <u>Terms and conditions apply</u>{" "}
            </span>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FooterContainer;
